import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export interface IGetOpenMarketProductsMetaParams {
  status: string;
  count: number;
  page?: number;
  machineType?: string;
  machineId?: string;
  brand?: string;
  minEngineOutputPs?: number;
  maxEngineOutputPs?: number;
  minPrice?: number;
  maxPrice?: number;
  sort?: string;
  rowConfig?: string;
  minOperationTime?: number;
  maxOperationTime?: number;
}

export interface IGetOpenMarketProductsMetaReturn {
  totalCount: number;
  brands: Array<{
    id: string;
    tractorCount: number;
  }>;
}

export const getOpenMarketProductsMeta = async ({
  searchParam,
}: {
  searchParam: IGetOpenMarketProductsMetaParams;
}): Promise<IGetOpenMarketProductsMetaReturn> => {
  const urlSearchParams = createURLSearchParams(searchParam);
  return customAxios.get(`/user-sell-tractors/meta?${urlSearchParams}`);
};
